angular
    .module("skillBuilderSaaS")
    .factory("templateCacheBusterService", ["$sessionStorage", function ($sessionStorage) {
        return {
            "request": function (config) {
                if (config.url.indexOf("app/") !== -1) {
                    if ($sessionStorage.version)
                        config.url = config.url + "?v=" + $sessionStorage.version;
                }
                return config;
            }
        };
    }]);
